import { ref, reactive } from 'vue'
import { useStore } from '~/store'
import { ElMessageBox } from 'element-plus'
import { updatePwd } from '~/api/userManage'
import { notice } from '~/utils/util'

export function useRepassWord() {
  const store = useStore()
  // 修改密码
  const formDialogRef = ref(null)
  const formRef = ref(null)
  const form = reactive({
    userName: '',
    oldPassword: '',
    password: '',
    repassword: ''
  })

  const validatePass = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('确认密码不能为空'))
    } else if (value !== form.password) {
      callback(new Error("新密码与确认密码不一致!"))
    } else if (value.length < 6 || value.length > 16) {
      callback(new Error("新密码长度在6-16位之间"))
    } else if (value === form.oldPassword) {
      callback(new Error("新密码不能与旧密码相同"))
    } else {
      callback()
    }
  }

  const rules = {
    oldPassword: [
      { required: true, message: '旧密码不能为空', trigger: 'blur' },
    ],
    password: [
      { required: true, validator: validatePass, trigger: 'blur' },
      { min: 3, max: 16, message: '新密码长度在3位16位之间', trigger: 'blur' }
    ],
    repassword: [
      { required: true, validator: validatePass, trigger: 'blur' },
      { min: 6, max: 16, message: '密码长度在6位16位之间', trigger: 'blur' }
    ]
  }

  const onSubmit = () => {
    formRef.value.validate((valid) => {
      if (!valid) {
        return false
      }
      formDialogRef.value.showLoading()
      form.userName = store.user.userName
      updatePwd(form).then(res => {
        if (res.code == 20000) {
          notice('修改密码成功，请重新登录')
          store.logout()
        }
      }).finally(() => {
        formDialogRef.value.hideLoading()
      })
    })
  }

  const openRePasswordForm = () => formDialogRef.value.open()

  return {
    formDialogRef,
    form,
    rules,
    formRef,
    onSubmit,
    openRePasswordForm
  }
}

export function useLogout() {
  const store = useStore()
  function handleLogout() {
    ElMessageBox.confirm('是否退出登录？', '提示',
      { confirmButtonText: '确定', cancelButtonText: '取消', type: '提示' }).then(() => {
        store.logout()
        // 提示退出登录成功
        notice('退出登录成功')
      })
  }

  return {
    handleLogout
  }
}
